import React from 'react';
import './Home.scss';
import { useNavigate } from 'react-router-dom';

export const Home = (): JSX.Element => {
	const navigate = useNavigate();

	const onNavClick = (path: string): void => {
		navigate(path);
	};

	return (
		<div className="homeContainer">
			<div className="homeNavButton" onClick={(): void => onNavClick('/restaurantManagement')}>
				ניהול מסעדה
			</div>
			<div className="homeNavButton" onClick={(): void => onNavClick('/orders')}>
				הזמנות
			</div>
		</div>
	);
};
